import { AuthManager } from '@goodt-wcore/managers';
import { Http } from './Http';

/**
 * @implements {import('./types').ITransportConstructor}
 * @extends {Http}
 */
class HttpAuth extends Http {
    /**
     * @type {AuthManager}
     * @private
     */
    _authManager = AuthManager.instance;

    /**
     * @param {AuthManager} authManager
     */
    setAuthManager(authManager) {
        this._authManager = authManager;
    }

    /**
     * Constructor
     *
     * @param {import('./types').ITransportOptions} [transportOptions={}]  transport base request config
     * @param {import('./types').ITransportExtraOptions} [extraOptions={}]  transport extra options
     */
    constructor(transportOptions = {}, extraOptions = {}) {
        super(transportOptions, extraOptions);
        this._axios.interceptors.request.use((config) => {
            const { adapter } = this._authManager;
            if (adapter == null) {
                return config;
            }
            return adapter
                .init()
                .then(() => adapter.updateToken())
                .then(() => {
                    const configFinal = { ...config };
                    configFinal.headers.Authorization = `Bearer ${adapter.token}`;
                    return configFinal;
                })
                .catch((error) => {
                    this._authManager.authError(error);
                    return config;
                });
        });
    }
}

export { HttpAuth, HttpAuth as default };
